// extracted by mini-css-extract-plugin
module.exports = {"description-body":"description-body__description-body___15Ipc"};